import { createSelector } from "reselect";
import { getAbTestsSelector } from "../../app/appSelectors";
import { AB_TESTS_NAMES } from "./abTestsConstants";

export const getAbTestLandingPage = createSelector(
    getAbTestsSelector, abTests => abTests[AB_TESTS_NAMES.LANDING_PAGE]
);

export const getAbTestMobileDepositBonusPrimaryButton = createSelector(
    getAbTestsSelector, abTests => abTests[AB_TESTS_NAMES.MOBILE_DEPOSIT_BONUS_PRIMARY_BUTTON] || 0
);
